
jQuery(document).ready(function () {

    if(jQuery('.button.read-more').length) {

        jQuery('.button.read-more').click(function (e) { 
            read_more_el = jQuery(this).parent().parent().find('.read-more-content');
            if(read_more_el.hasClass('hide')) {
                read_more_el.removeClass('hide');
            } else {
                read_more_el.addClass('hide');
            }
        });

    }

});
